import type { Server } from "miragejs";
import { Response, createServer } from "miragejs";

import { listTicketsMock } from "./mocks/list-tickets";
import { mockSupportUserStatus } from "./mocks/new-ticket";
import { ticketMock } from "./mocks/tickets";
import {
  BFF_SUPPORT_TICKETS_ENDPOINT,
  BFF_SUPPORT_TICKETS_LIST,
  BFF_SUPPORT_TICKETS_NEW,
  BFF_SUPPORT_USER_STATUS,
  BFF_URL,
  SEND_MESSAGE,
} from "../urls";
import { markdownTexts } from "pages/chat/components/lis-chat/settings";

function makeMockServer(): Server {
  return createServer({
    environment: process.env.NODE_ENV,
    routes() {
      // Config
      this.urlPrefix = BFF_URL;
      this.timing = 400;

      // Support Tickets
      this.get(BFF_SUPPORT_TICKETS_LIST, () => listTicketsMock);
      this.get(
        BFF_SUPPORT_TICKETS_ENDPOINT("500bL00000EOxjlQAD"),
        () => ticketMock
      );
      this.post(BFF_SUPPORT_TICKETS_NEW, () => new Response(201));

      // New Ticket Form
      this.get(BFF_SUPPORT_USER_STATUS, () => mockSupportUserStatus);

      // chat
      this.post(SEND_MESSAGE, () => ({
        answer: markdownTexts[3],
        chat_message_id: Math.random(),
      }));

      // Passthrough
      this.passthrough("https://api-js.mixpanel.com/**");
      this.passthrough("https://auth-engine.olist.com/realms/**");
      this.passthrough(
        "http://localhost:3001/support/new-ticket/teste/manifest.json"
      );
      this.passthrough("https://internal-wiki.olist.com/graphql");
      this.passthrough("https://olist.my.salesforce-scrt.com");
      this.passthrough();
    },
  });
}

export function initMockServer(): void {
  if (process.env.REACT_APP_MOCK_SERVER === "true") {
    makeMockServer();
  }
}
